const selectInventorySegments = campaignOrDraft => campaignOrDraft.inventorySegments ?? [];

export const selectInventoryValidForPublish = campaignOrDraft => {
  const inventorySegments = selectInventorySegments(campaignOrDraft);

  return inventorySegments.length > 0;
};

export const selectInventoryValidForSave = selectInventoryValidForPublish;
